import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

const PrivateRoute = ({ children, role }) => {
  // 1. Get 'loading' and 'user' from context
  const { user, loading, isAuthenticated } = useAuth();
  const { t } = useTranslation();

  // 2. IF LOADING: Wait! Do not redirect yet.
  if (loading) {
    return <div>{t('general.loading')}</div>;
  }

  // 3. CHECK AUTH
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // 4. CHECK ROLE (If a specific role is required — supports string or array)
  if (role && user && !([].concat(role)).includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;